export class IsSynchronizingEvent {
  constructor(public readonly isSynchronizing: boolean) {}
}
